import { components } from './components';
import { contracts } from './contracts';
import { emailLink } from './emailLink';
import { packages } from './packages';
import { reschedule } from './reschedule';
import { schedule } from './schedule';
import { success } from './success';
import { unit } from './unit';

const pt = {
  ...components,
  ...contracts,
  ...emailLink,
  ...packages,
  ...reschedule,
  ...schedule,
  ...success,
  ...unit,
};

export default pt;
